<ng-container *transloco="let t">
  <div class="step-container">
    <div class="step-content">
      <!-- Back Button -->
      <button class="back-button" (click)="onBack()" [disabled]="loading()">
        <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
      </button>

      <!-- Re-auth Banner -->
      @if (bannerVariant) {
        <lib-connection-attempt-banner
          [variant]="bannerVariant"
          [integrationEnabled]="integrationEnabled"
          [integrationEntityName]="integrationEntityName"
          [customMessage]="
            failureMessageKey ? t(failureMessageKey) : failureMessage
          "></lib-connection-attempt-banner>
      }

      @if (shouldShowFailureMetadata) {
        <div class="failure-metadata">
          @if (failureCode) {
            <p class="failure-meta-item">
              <span class="failure-meta-label">
                {{ t('lang.credentials_failure_code_label') }}
              </span>
              <span class="failure-meta-value">{{ failureCode }}</span>
            </p>
          }
          @if (formattedFailureOccurredAt) {
            <p class="failure-meta-item">
              <span class="failure-meta-label">
                {{ t('lang.credentials_failure_time_label') }}
              </span>
              <span class="failure-meta-value">
                {{ formattedFailureOccurredAt }}
              </span>
            </p>
          }
        </div>
      }

      <!-- Header -->
      <div class="header-section">
        <lib-connection-entity-brand-chip
          [displayName]="entityDisplayName"
          [iconUrl]="entityIconUrl" />

        <h1 class="step-title">{{ t(credentialsTitleKey) }}</h1>
        <p class="step-description">
          {{
            t(credentialsDescriptionKey, {
              pro: entityDisplayName,
              entity: integrationEntityName,
            })
          }}
        </p>
      </div>

      <!-- Credentials Form (Dynamic) -->
      <form [formGroup]="credentialsForm" (ngSubmit)="onSubmit()">
        @for (field of credentialFields; track field.controlName) {
          <div class="mz-form-row vertical for-text">
            <div class="mz-label">
              <label>
                {{ getFieldLabel(field) }}
                @if (isFieldRequired(field)) {
                  <span class="required">*</span>
                }
              </label>
            </div>
            <div class="mz-input">
              <div
                class="mz-input-container"
                [class.error]="hasError(field.controlName)">
                <input
                  [type]="getFieldType(field)"
                  [formControlName]="field.controlName"
                  [placeholder]="getFieldPlaceholder(field)"
                  [disabled]="loading()"
                  [autocomplete]="field.controlName"
                  (input)="onFieldInput(field, $event)" />
                @if (isPasswordField(field)) {
                  <button
                    type="button"
                    class="icon eye-toggle"
                    (click)="togglePasswordVisibility(field.controlName)"
                    [disabled]="loading()">
                    @if (isPasswordVisible(field.controlName)) {
                      <mzic-svg src="assets/icons/mzic-eye-filled-hidden.svg" />
                    } @else {
                      <mzic-svg src="assets/icons/mzic-eye.svg" />
                    }
                  </button>
                }
                @if (hasError(field.controlName)) {
                  <div
                    class="icon error"
                    [class.with-trailing-icon]="isPasswordField(field)">
                    <mzic-svg
                      src="assets/icons/mzic-close-filled.svg"
                      class="red" />
                  </div>
                }
              </div>
              @if (hasError(field.controlName)) {
                <p class="error-message">
                  {{ getFieldError(field) }}
                </p>
              }
            </div>
          </div>
        }

        <!-- Info Note -->
        <div class="info-note">
          <mzic-svg src="assets/icons/mzic-info.svg" />
          <p>
            {{ t(credentialsInfoNoteKey, { entity: integrationEntityName }) }}
          </p>
        </div>
      </form>
    </div>

    <!-- Footer -->
    <div class="step-footer">
      <button
        class="primary-button"
        [disabled]="!credentialsForm.valid || loading()"
        (click)="onSubmit()">
        @if (loading()) {
          <mzic-spinner />
        }
        {{ t(submitLabelKey) | uppercase }}
      </button>
    </div>
  </div>
</ng-container>
